import Column from '@components/Column';
import Text from '@components/Text';
import styled from '@emotion/styled';
import usePriceUnit from '@hooks/item/usePriceUnit';
import { UserCouponResponse } from '@models/coupon';
import { useTranslation } from 'react-i18next';

interface Props {
    coupon: UserCouponResponse;
}

const ALL_SHOPS = ['전체매장', 'ALL_SHOPS'];

function CouponText({ coupon }:Props) {
    const { t } = useTranslation('coupon');
    const {
        availableShops,
        couponName,
        discountMethod,
        discountValue,
    } = coupon;
    const priceUnit = usePriceUnit();
    return (
        <Column fullWidth align='center' spacing={2}>
            <BreakText fontWeight='medium' align='center'>
                {ALL_SHOPS.includes(availableShops) ? t('detail.allShops') : availableShops}
            </BreakText>
            <BreakText size='title' fontWeight='bold' align='center'>
                {couponName}
            </BreakText>
            {/* NOTE:: BOGO 쿠폰은 할인 금액이 없음 */}
            {discountMethod !== 'BOGO' && <Text size='title' fontWeight='bold' color='var(--color-text-error)'>
                {discountValue.toLocaleString()}{discountMethod === 'RATE' ? '%' : priceUnit}
            </Text>}
        </Column>
    );
}

const BreakText = styled(Text)`
    word-break: break-word;
`;

export default CouponText;
